import { useAuth } from '@/context/AuthContext'
import { Button, Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, Stack, Text, type UseDisclosureReturn } from '@chakra-ui/react'
import type { ReactNode } from 'react'
import { ChangePasswordForm } from './forms/ChangePasswordForm'

export const ChangePasswordModal = ({ isOpen, onClose, closeable = true, description }: { closeable?: boolean, description?: ReactNode } & UseDisclosureReturn) => {
  const {logout, isLoggingOut } = useAuth()

  return <Modal isOpen={isOpen} onClose={onClose} isCentered closeOnEsc={closeable} closeOnOverlayClick={closeable}>
    <ModalOverlay 
      backdropFilter='auto'
      bg='blackAlpha.300'
      backdropBlur='10px' 
    />
    <ModalContent>
      <ModalHeader pt={6}>
        Změna hesla
      </ModalHeader>
      <ModalBody as={Stack} gap={6} pb={6}>
        {description && <Text>{description}</Text>}
        <ChangePasswordForm onPasswordChanged={onClose} />
      </ModalBody>
      <Button variant='outline' pos="absolute" bottom={6} left={6} isLoading={isLoggingOut} onClick={() => logout()}>Odhlásit se</Button>
    </ModalContent>
  </Modal>

}